module.exports = __webpack_public_path__ + "static/media/Logo__MatrixLabs.4aa45281.svg";